module.exports = __webpack_public_path__ + "img/replica.9ddd9228.svg";